import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  WebAngularSharedDataAccessApplicationApiModule,
  PermissionsModule,
} from '@content-platform/web/angular/shared/data-access/application-api';
import { AuthModule } from '@content-platform/web-angular-shared-util-auth';
import { WebAngularSharedUtilErrorHandlingModule } from '@content-platform/web-angular-shared-util-error-handling';
import { LoggingModule } from '@content-platform/web-angular-shared-util-logging';
import { NavigationModule } from '@content-platform/web-angular-shared-ui-navigation';
import { DevelopmentModule } from '@content-platform/web-angular-shared-util-development';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { NxModule } from '@nrwl/angular';
import * as environment from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardModule } from './dashboard/dashboard.module';
import { CustomSerializer, reducers } from './reducers';
import {
  RouterStateSerializer,
  StoreRouterConnectingModule,
  DefaultRouterStateSerializer,
} from '@ngrx/router-store';
import { InterceptorsModule } from '@content-platform/web-angular-shared-util-interceptors';
import { ReusableUiFeatureFlagsModule } from '@content-platform/reusable-ui/feature-flags';
import { WebAngularSharedDataAccessFeatureFlagApiModule } from '@content-platform/web-angular-shared-data-access-feature-flag-api';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NxModule.forRoot(),
    StoreModule.forRoot(reducers, {
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
      },
    }),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({ logOnly: environment.production }),
    WebAngularSharedDataAccessApplicationApiModule.forRoot('Home'),
    AuthModule,
    NavigationModule.forRoot(),
    WebAngularSharedUtilErrorHandlingModule.forRoot({ handleAllFailActions: true }),
    DashboardModule,
    AppRoutingModule,
    PermissionsModule,
    StoreRouterConnectingModule.forRoot({ serializer: DefaultRouterStateSerializer }),
    LoggingModule.forRoot(),
    DevelopmentModule.forRoot(),
    InterceptorsModule,
    ReusableUiFeatureFlagsModule,
    WebAngularSharedDataAccessFeatureFlagApiModule,
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  providers: [{ provide: RouterStateSerializer, useClass: CustomSerializer }],
})
export class AppModule {}
